const changeLayoutModeAsync = (context, payload) => {
    context.commit('changeLayoutMode', payload);
}


export default {
    changeLayoutModeAsync
}
